<script>
import Layout from "../../layouts/print";
import appConfig from "@/app.config";
import { saleService } from "../../../services/saleservice/sale.service";
import moment from "moment";

/* eslint-disable no-console */
export default {
  page: {
    title: "Invoice Detail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      title: "Payment Detail",
      items: [
        {
          text: "Schedule",
          href: "/",
        },
        {
          text: "Detail",
          active: true,
        },
      ],
      saledetail: null,
      saleschedule: null,
      registerDates: [],
      loan: null,
      loanDuration: 0,
      
    };
  },
  mounted() {

    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else if('propertyid' in this.$route.query) {
      this.loadingPropertyById(this.$route.query.propertyid);
    }
    
  },
  methods: {
    
    loadingData: function(id) {
      
      this.fetchingStats = false;
      saleService.saledetail(id)
        .then(response => {
          this.saledetail = response.data;
          this.registerDates = this.saledetail.register_date.split('-');
        });

      saleService.saleschedule(id)
        .then(response => {
          this.saleschedule = response.data;
          this.loan = this.saleschedule.find(item => { return item.interest > 0 });
          let index = this.saleschedule.findIndex(item => item.interest > 0);

          this.loanDuration = this.saleschedule.length - index;
        });
      

    },

    loadingPropertyById: function(id) {
      this.fetchingStats = false;

      saleService.getOneByProperty(id).then(response => {
        if(response.data != null) {
          saleService.saledetail(response.data.id)
            .then(response => {
              this.saledetail = response.data;
              this.registerDates = this.saledetail.register_date.split('-');
              
            });

          saleService.saleschedule(response.data.id)
            .then(response => {
              this.saleschedule = response.data;

              this.loan = this.saleschedule.find(item => { return item.interest > 0 });
              let index = this.saleschedule.findIndex(item => item.interest > 0);

              this.loanDuration = this.saleschedule.length - index;
            });
        }
      });
    },

    formatCurrency(value, sign = '$') {

      let decimal = '.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;

    },

    formatDate : function (date) {
        return moment(date, 'YYYY-MM-DD').format('DD/MMM/YYYY');
    },

    getDay(date) {
      const weekday = ["អាទិត្យ", "ច័ន្ទ", "អង្គារ", "ពុធ", "ព្រហស្បតិ៍", "សុក្រ", "សៅរ៍"];
      let d = new Date(date);
      
      return weekday[d.getDay()];
      // console.log(date);
      // return '';
    }
  },
};

</script>

<template>
  <Layout>
    
        <center>
          <div class="col dblack box-a4-long">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="14%"><p>&nbsp;</p></td>
                <td width="86%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khm h6">លំនៅឋាន អេចស៊ី ឯ.ក</p>
                  <p class="enb h6">LOMNOV THAN HC CO., LTD</p>
                  <p class="en h7">Address: #742 Street:1952, Bayap Village, Sangkat Phnom Penh Thmei, Khan SenSok, Phnom Penh Capital</p>
                  <p class="en h7">Tell: 078 554 077 | 015 554 077 Email: account@h-residence.net</p>
                </td>
              </tr>
              <tr><td colspan="2"><div class="hr-2"></div></td></tr>
            </table>
            <br/>
            <table width="100%" class="content-general"><tr><td class="center">
              <p class="h5 khm">កាលវិភាគបង់ប្រាក់</p>
              <p class="h5 enb">PAYMENT SCHEDULE</p>
              <p class="">
                <img src="@/assets/images/bellow01.png" style="width: 130px;"/>
              </p>
            </td></tr></table>
            <br>

            <table class="content-general h8 detail-table left" width="100%">
              
              <tr>
                <td style="width:4cm"><p class="en">Unit Code</p></td>
                <td style="width:2.8cm"><p class="en"><b>: {{saledetail && saledetail.property_code}} Floor: {{saledetail && (saledetail.property_floor + '').padStart(2, '0')}}</b></p></td>
                <td style="width:3cm"><p class="en">Plan</p></td>
                <td style="width:4.2cm"><p class="en"><b>: {{saledetail && saledetail.project_name}}</b></p></td>
                <td style="width:2.2cm"><p class="en">Seller</p></td>
                <td><p class="en"><b>: {{saledetail && saledetail.seller_name}}</b></p></td>
              </tr>
              <tr>
                <td><p class="en">Unit Price</p></td>
                <td><p class="en"><b>: {{saledetail && formatCurrency(saledetail.amount, '')}} USD</b></p></td>
                <td><p class="en">Contract Type</p></td>
                <td><p class="en"><b>: {{saledetail && saledetail.contract_type}}</b></p></td>
                <td><p class="en">Loan Code</p></td>
                <td><p class="en"><b>: {{loan ? saledetail && saledetail.loan_code : ''}}</b></p></td>
              </tr>
              <tr>
                <td><p class="en">Discount</p></td>
                <td><p class="en"><b>: {{saledetail && formatCurrency(saledetail.discount, '')}} USD</b></p></td>
                <td><p class="en">Customer Code</p></td>
                <td><p class="en"><b>: {{saledetail && saledetail.customer_code}}</b></p></td>
                <td><p class="en">Loan Date</p></td>
                <td><p class="en"><b>: {{loan && loan.pay_date_show}}</b></p></td>
              </tr>
              <tr>
                <td><p class="en">Price</p></td>
                <td><p class="en"><b>: {{saledetail && formatCurrency(saledetail.sale_price, '')}} USD</b></p></td>
                <td><p class="en">Customer Name</p></td>
                <td><p class="en"><b>: {{saledetail && saledetail.customer_name}}</b></p></td>
                <td><p class="en">Loan Amount</p></td>
                <td><p class="en"><b>: {{loan && formatCurrency(loan.principal_pay + loan.balance)}} USD</b></p></td>
              </tr>
              <tr>
                <td><p class="en">Booking/Principal Paid</p></td>
                <td><p class="en"><b>: {{saledetail && formatCurrency(saledetail.deposit, '')}} USD</b></p></td>
                <td><p class="en">Partner Name</p></td>
                <td><p class="en"><b>: {{saledetail && saledetail.partner_name}}</b></p></td>
                <td><p class="en">Interest</p></td>
                <td><p class="en"><b>: {{loan ? '1%' : '0%'}}/Month</b></p></td>
              </tr>
              <tr>
                <td><p class="en">Principal Paid Total</p></td>
                <td><p class="en"><b>: {{saledetail && formatCurrency(saledetail.principle_pay, '')}} USD</b></p></td>
                <td><p class="en">Customer Phone</p></td>
                <td><p class="en"><b>: {{saledetail && saledetail.customer_phone}}</b></p></td>
                <td><p class="en">Loan Duration</p></td>
                <td><p class="en"><b>: {{saledetail && saledetail.loanDuration}} ខែ</b></p></td>
              </tr>
              <tr>
                <td><p class="en">Principal Pendding</p></td>
                <td><p class="en"><b>: {{saledetail && formatCurrency(saledetail.principle_pending, '')}} USD</b></p></td>
                <td><p class="en">ID Card No</p></td>
                <td><p class="en"><b>: {{saledetail && saledetail.id_no}}</b></p></td>
                <td><p class="en">Monthly Pay</p></td>
                <td><p class="en"><b>: {{loan && formatCurrency(loan.integer_pay, '')}} USD</b></p></td>
              </tr>
            </table>
            <div style="height: 5px;"></div>
            <table style="width:100%">
              <tr><td colspan="2"><div class="hr-2"></div></td></tr>
            </table>
            <div style="height: 5px;"></div>
            <table class="content-general h8 schedule-table" width="100%">
              
                <tr class="thead">
                  <td><p class="en">ល.រ</p></td>
                  <td colspan="2"><p class="en">Pay Date</p></td>
                  <td><p class="en">Monthly Pay</p></td>
                  <td><p class="en">Principal</p></td>
                  <td><p class="en">Interest</p></td>
                  <td><p class="en">Balance</p></td>
                  <td><p class="en">Paid Date</p></td>
                  <td><p class="en">Note</p></td>
                </tr>
              <tbody>
                <tr v-for="(list, index) in saleschedule" :key="list.id">
                  <td><p class="en">{{index+1}}</p></td>
                  <td><p class="en">{{`${list.pay_date_show}`}}</p></td>
                  <td><p class="en" style="font-size: 7pt;">{{list.day_show}}</p></td>
                  <td><p class="en" style="text-align: right; padding-right: 10px">{{formatCurrency(list.integer_pay)}}</p></td>
                  <td><p class="en" style="text-align: right; padding-right: 10px">{{formatCurrency(list.principal_pay)}}</p></td>
                  <td><p class="en" style="text-align: right; padding-right: 10px">{{formatCurrency(list.interest)}}</p></td>
                  <td><p class="en" style="text-align: right; padding-right: 10px">{{formatCurrency(list.balance)}}</p></td>
                  <td><p class="en" style="text-align: center;" v-for="date_list in list.pay_list" :key="date_list.id">{{date_list.pay_date}}</p></td>
                  <td v-if="list.schedule_status_id == 3" style="text-align:center; font-size: 17pt; line-height: 40%; color: #656569;"><span>&#x2611;</span></td>
                  <td v-else style="text-align:center; font-size: 25pt; line-height: 40%; color: #656569;"><span>&squ;</span></td>
                </tr>
                <tr>
                  <td colspan="3"><p class="en" style="font-size: 11pt;">Total</p></td>
                  <td><p class="en" style="font-size: 11pt; text-align: right; padding-right: 10px">{{formatCurrency(saleschedule.reduce((sum, item) => sum + item.integer_pay, 0))}}</p></td>
                  <td><p class="en" style="font-size: 11pt; text-align: right; padding-right: 10px">{{formatCurrency(saleschedule.reduce((sum, item) => sum + item.principal_pay, 0))}}</p></td>
                  <td><p class="en" style="font-size: 11pt; text-align: right; padding-right: 10px">{{formatCurrency(saleschedule.reduce((sum, item) => sum + item.interest, 0))}}</p></td>
                  <td colspan="3"><p class="en"></p></td>
                  
                </tr>
              </tbody>
            </table>
            <br>
            <table width="100%" class="center">
              <!-- <tr><td colspan="3" class="right"><p class="en">Date {{registerDates[1]}}-{{registerDates[2]}}-{{registerDates[0]}} </p></td></tr>-->
              <tr><td colspan="3" class="right"><p class="en">Date {{formatDate(saledetail.register_date)}} </p></td></tr>
              <tr>
                <td><p class="enb">Thumbprint of Party “B”</p></td>
                <td><p class="enb">Thumbprint of Party “B” Partner</p></td>
                <td><p class="enb">Thumbprint of Party “A”</p></td>
              </tr>
              <tr>
                <td>
                  <p>
                    <br/><br/><br/><br/>
                  </p>
                  <p style="text-align: center" class="khm">{{saledetail && saledetail.customer_name}}</p>
                </td>
                <td>
                  <p>
                    <br/><br/><br/><br/>
                  </p>
                  <p style="text-align: center" class="khm">{{saledetail && saledetail.partner_name}}</p>
                </td>
                <td>
                  <p>
                    <br/><br/><br/><br/>
                  </p>
                  <p class="khm">LIM TRY</p>
                </td>
              </tr>
            </table>
          </div>
        </center>
  </Layout>
</template>